module.exports = __webpack_public_path__ + "assets/img/00179.ef522f34.png";